import { render, staticRenderFns } from "./TopluHacizGonderIslemDetayView.vue?vue&type=template&id=3cfc3078&scoped=true"
import script from "./TopluHacizGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TopluHacizGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc3078",
  null
  
)

export default component.exports